<template>
  <div class="card manifesto-page">
    <div
      v-if="carregando"
      class="manifesto-loading"
      role="status"
      aria-live="polite"
    >
      <div class="manifesto-loading__box">
        <b-spinner class="mb-2" variant="primary" label="Carregando"></b-spinner>
        <strong>{{ mensagemCarregando }}</strong>
        <small>Aguarde a resposta da SEFAZ. Não feche esta tela.</small>
      </div>
    </div>

    <div class="card-body">
      <div class="row mb-3">
        <div class="col-md-12">
          <input
            id="modo-ultimos-3-meses"
            v-model="modoConsulta"
            type="radio"
            value="ultimos_3_meses"
            :disabled="carregando"
          />
          <label class="mr-4 mb-0" for="modo-ultimos-3-meses"
            >Continuar a partir do último NSU</label
          >
          <input
            id="modo-pesquisar-nsu"
            v-model="modoConsulta"
            type="radio"
            value="pesquisar_nsu"
            :disabled="carregando"
          />
          <label class="mb-0" for="modo-pesquisar-nsu">Pesquisar por NSU</label>
        </div>
      </div>

      <div class="row mb-2" v-if="modoConsulta === 'ultimos_3_meses'">
        <div class="col-md-12">
          <div class="alert alert-light border mb-0 py-2">
            Último NSU do Manifesto:
            <strong>{{
              empresaResumo.manifesto_ultimo_nsu || "000000000000000"
            }}</strong>
            <small class="d-block text-muted">
              A próxima consulta continua a partir deste NSU gravado na empresa.
            </small>
          </div>
        </div>
      </div>

      <div class="row mb-2" v-if="modoConsulta === 'pesquisar_nsu'">
        <div class="col-md-12">
          <label for="manifesto-nsu-pesquisa">NSU</label>
          <input
            id="manifesto-nsu-pesquisa"
            v-model="nsuConsulta"
            type="text"
            class="form-control text-left"
            maxlength="15"
            inputmode="numeric"
            :disabled="carregando"
          />
        </div>
      </div>

      <div class="row mb-2">
        <div class="col-md-12">
          <label>Pesquisa</label>
          <multiselect
            v-model="select_pesquisa"
            :options="opcoes"
            label="nome"
            track-by="id"
            :disabled="carregando"
          >
          </multiselect>
        </div>
      </div>
    </div>
    <div class="card-body">
      <div
        v-if="bloqueadoConsumoIndevido"
        class="alert alert-warning"
        role="alert"
      >
        Consumo indevido (cStat 656). Aguarde
        <strong>{{ tempoRestanteConsumoIndevido }}</strong>
        para uma nova consulta. Novas tentativas reiniciam a contagem da SEFAZ.
      </div>

      <div class="row">
        <div class="col-md-12">
          <button
            class="btn btn-primary mr-2"
            @click.prevent="busca()"
            :disabled="carregando || bloqueadoConsumoIndevido"
          >
            <b-spinner
              v-if="carregando"
              small
              type="grow"
              class="mr-1"
            ></b-spinner>
            {{ carregando ? "Consultando..." : "Pesquisar" }}
          </button>
          <button
            class="btn btn-light"
            @click.prevent="back()"
            :disabled="carregando"
          >
            Voltar
          </button>
        </div>
      </div>

      <list-manifesto-nfe
        :notas="documentos"
        :consultou="consultou"
        :carregando="carregando"
        :consulta-bloqueada="bloqueadoConsumoIndevido"
        @consultar-novamente="busca"
        @excluir="confirmarExclusao"
        @manifestar="abrirManifestacao"
        @baixar="baixarXml"
      />
    </div>

    <b-modal
      id="modal-manifestar-nfe"
      title="Manifestar NF-e"
      ok-title="Manifestar"
      cancel-title="Cancelar"
      :ok-disabled="!manifestacaoValida || carregando"
      @ok="enviarManifestacao"
    >
      <p class="mb-2">
        NF-e <strong>{{ notaSelecionada ? notaSelecionada.numero : "" }}</strong>
      </p>
      <div class="form-group">
        <label for="tipo-evento-manifesto">Manifestação</label>
        <select
          id="tipo-evento-manifesto"
          v-model="manifestacao.tpEvento"
          class="form-control"
        >
          <option disabled value="">Selecione o tipo de manifestação</option>
          <option
            v-for="evento in eventosManifestacao"
            :key="evento.id"
            :value="evento.id"
          >
            {{ evento.nome }}
          </option>
        </select>
      </div>
      <div class="form-group" v-if="manifestacao.tpEvento === '210240'">
        <label for="justificativa-manifesto">Justificativa</label>
        <textarea
          id="justificativa-manifesto"
          v-model.trim="manifestacao.xJust"
          class="form-control"
          rows="3"
          maxlength="255"
          placeholder="Informe pelo menos 15 caracteres"
        ></textarea>
        <small class="form-text text-muted">
          {{ manifestacao.xJust.length }}/255 caracteres
        </small>
      </div>
    </b-modal>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";
import { http } from "../../../helpers/easyindustriaapi/config";
import ListManifestoNfe from "./listManifestoNfe.vue";

const NSU_PADRAO = "000000000000000";
const CONSUMO_INDEVIDO_MS = 60 * 60 * 1000;

export default {
  components: {
    Multiselect,
    ListManifestoNfe,
  },
  props: {
    show_manifesto: { type: Boolean },
    currentEmpresa: { type: Object, default: null },
  },
  data() {
    const opcoes = [
      { id: 1, nome: "Todas as NF-e" },
      {
        id: 2,
        nome: "Apenas NF-e sem Manifestação de Confirmação, Desconhecimento ou Não realizada",
      },
      {
        id: 3,
        nome: "Apenas NF-e sem Manifestação de Ciência, Confirmação, Desconhecimento ou Não realizada",
      },
    ];

    return {
      modoConsulta: "ultimos_3_meses",
      nsuConsulta: NSU_PADRAO,
      carregando: false,
      mensagemCarregando: "Consultando SEFAZ...",
      consultou: false,
      documentos: [],
      notaSelecionada: null,
      agoraMs: Date.now(),
      consumoIndevidoEmMs: null,
      consumoIndevidoTimer: null,
      manifestacao: {
        tpEvento: "",
        xJust: "",
      },
      eventosManifestacao: [
        { id: "210200", nome: "Confirmada (Confirmação da Operação)" },
        { id: "210210", nome: "Ciência da Operação" },
        { id: "210220", nome: "Operação Desconhecida" },
        { id: "210240", nome: "Operação não Realizada" },
      ],
      opcoes,
      select_pesquisa: opcoes[0],
      empresaResumo: {
        id: null,
        cnpj: "",
        uf: "",
        manifesto_ultimo_nsu: NSU_PADRAO,
        manifesto_filtro_emitente: 1,
      },
    };
  },
  watch: {
    modoConsulta(novoModo) {
      if (novoModo === "pesquisar_nsu") {
        this.nsuConsulta =
          this.empresaResumo.manifesto_ultimo_nsu || NSU_PADRAO;
      }
    },
  },
  created() {
    this.inicializarEmpresa();
    if (!this.select_pesquisa) {
      this.select_pesquisa = this.opcoes[0];
    }
    this.carregarConsumoIndevidoLocal();
    this.iniciarRelogioConsumoIndevido();
    this.carregarNotasSalvas();
  },
  beforeDestroy() {
    if (this.consumoIndevidoTimer) {
      clearInterval(this.consumoIndevidoTimer);
      this.consumoIndevidoTimer = null;
    }
  },
  computed: {
    manifestoConsumoIndevidoKey() {
      return this.empresaResumo.id
        ? `manifesto_consumo_indevido_${this.empresaResumo.id}`
        : null;
    },
    liberacaoConsumoIndevidoEm() {
      return this.consumoIndevidoEmMs
        ? this.consumoIndevidoEmMs + CONSUMO_INDEVIDO_MS
        : null;
    },
    msRestanteConsumoIndevido() {
      if (!this.liberacaoConsumoIndevidoEm) {
        return 0;
      }

      return Math.max(0, this.liberacaoConsumoIndevidoEm - this.agoraMs);
    },
    bloqueadoConsumoIndevido() {
      return this.msRestanteConsumoIndevido > 0;
    },
    tempoRestanteConsumoIndevido() {
      const totalSegundos = Math.ceil(this.msRestanteConsumoIndevido / 1000);
      const horas = Math.floor(totalSegundos / 3600);
      const minutos = Math.floor((totalSegundos % 3600) / 60);
      const segundos = totalSegundos % 60;

      if (horas > 0) {
        return `${horas}h ${String(minutos).padStart(2, "0")}min ${String(
          segundos
        ).padStart(2, "0")}s`;
      }

      return `${minutos}min ${String(segundos).padStart(2, "0")}s`;
    },
    manifestacaoValida() {
      return (
        this.manifestacao.tpEvento &&
        (this.manifestacao.tpEvento !== "210240" ||
          this.manifestacao.xJust.length >= 15)
      );
    },
  },
  methods: {
    inicializarEmpresa() {
      const origem =
        this.currentEmpresa ||
        JSON.parse(localStorage.getItem("currentEmpresa") || "null");

      if (!origem || !origem.id) {
        this.makeToast("danger", "Empresa atual não encontrada.");
        return;
      }

      this.empresaResumo = {
        id: origem.id,
        cnpj: origem.cnpj || "",
        uf: origem.uf || "",
        manifesto_ultimo_nsu: origem.manifesto_ultimo_nsu || NSU_PADRAO,
        manifesto_filtro_emitente: Number(origem.manifesto_filtro_emitente || 1),
      };
      this.nsuConsulta = this.empresaResumo.manifesto_ultimo_nsu || NSU_PADRAO;
    },
    carregarConsumoIndevidoLocal() {
      if (!this.manifestoConsumoIndevidoKey) {
        this.consumoIndevidoEmMs = null;
        return;
      }

      const raw = localStorage.getItem(this.manifestoConsumoIndevidoKey);
      if (!raw) {
        this.consumoIndevidoEmMs = null;
        return;
      }

      const data = new Date(raw);
      if (Number.isNaN(data.getTime())) {
        localStorage.removeItem(this.manifestoConsumoIndevidoKey);
        this.consumoIndevidoEmMs = null;
        return;
      }

      this.consumoIndevidoEmMs = data.getTime();
      this.agoraMs = Date.now();

      if (this.msRestanteConsumoIndevido === 0) {
        this.limparConsumoIndevidoLocal();
      }
    },
    iniciarRelogioConsumoIndevido() {
      this.agoraMs = Date.now();
      if (this.consumoIndevidoTimer) {
        clearInterval(this.consumoIndevidoTimer);
      }
      this.consumoIndevidoTimer = setInterval(() => {
        this.agoraMs = Date.now();
        if (
          this.consumoIndevidoEmMs &&
          this.msRestanteConsumoIndevido === 0
        ) {
          this.limparConsumoIndevidoLocal();
        }
      }, 1000);
    },
    registrarConsumoIndevidoLocal() {
      if (!this.manifestoConsumoIndevidoKey) {
        return;
      }

      const registradoEm = new Date();
      localStorage.setItem(
        this.manifestoConsumoIndevidoKey,
        registradoEm.toISOString()
      );
      this.consumoIndevidoEmMs = registradoEm.getTime();
      this.agoraMs = Date.now();
    },
    limparConsumoIndevidoLocal() {
      if (this.manifestoConsumoIndevidoKey) {
        localStorage.removeItem(this.manifestoConsumoIndevidoKey);
      }
      this.consumoIndevidoEmMs = null;
      this.agoraMs = Date.now();
    },
    async busca() {
      if (!this.empresaResumo.id) {
        this.makeToast("danger", "Empresa atual não encontrada.");
        return;
      }

      if (this.bloqueadoConsumoIndevido) {
        this.makeToast(
          "warning",
          `Consumo indevido ativo. Aguarde ${this.tempoRestanteConsumoIndevido} para consultar novamente.`
        );
        return;
      }

      this.mensagemCarregando = "Consultando SEFAZ...";
      this.carregando = true;

      try {
        await this.postNsu();
      } finally {
        this.carregando = false;
      }
    },
    async carregarNotasSalvas() {
      if (!this.empresaResumo.id) {
        return;
      }

      this.mensagemCarregando = "Carregando notas salvas...";
      this.carregando = true;

      try {
        const response = await http.get("/nfe/manifestos", {
          params: { empresa_id: this.empresaResumo.id },
        });
        this.documentos = Array.isArray(response.data.documentos)
          ? response.data.documentos
          : [];
        this.consultou = true;

        const filtros = response.data.filtros || {};
        this.modoConsulta = filtros.modo || "ultimos_3_meses";
        this.empresaResumo.manifesto_ultimo_nsu =
          filtros.ultimo_nsu ||
          this.empresaResumo.manifesto_ultimo_nsu ||
          NSU_PADRAO;
        this.nsuConsulta =
          filtros.nsu ||
          this.empresaResumo.manifesto_ultimo_nsu ||
          NSU_PADRAO;
        this.select_pesquisa =
          this.opcoes.find(
            (opcao) => opcao.id === Number(filtros.filtro_manifestacao)
          ) || this.opcoes[0];
      } catch (error) {
        this.tratarErroHttp(error);
      } finally {
        this.carregando = false;
      }
    },
    makeToast(variant = null, message = "Erro genérico") {
      this.$bvToast.toast(message, {
        title: "Notificação",
        toaster: "b-toaster-bottom-right",
        variant: variant,
        solid: true,
        appendToast: true,
      });
    },
    async postNsu() {
      const payload = {
        empresa_id: this.empresaResumo.id,
        modo: this.modoConsulta,
        filtro_manifestacao: this.select_pesquisa ? this.select_pesquisa.id : 1,
        filtro_emitente: 1,
      };

      if (this.modoConsulta === "pesquisar_nsu") {
        const nsuDigits = (this.nsuConsulta || "").replace(/\D/g, "");
        if (!nsuDigits) {
          this.makeToast("danger", "Informe o número do NSU.");
          return;
        }
        payload.nsu = nsuDigits.padStart(15, "0").slice(-15);
      }

      try {
        const response = await http.post("/nfe/nsu", payload, {
          validateStatus: (status) => status < 500,
        });

        const cStat = String(response.data.cStat || "");
        const documentos = Array.isArray(response.data.documentos)
          ? response.data.documentos
          : [];

        if (response.status === 200 && response.data.success) {
          this.limparConsumoIndevidoLocal();
          if (response.data.ultNSU) {
            this.empresaResumo.manifesto_ultimo_nsu = response.data.ultNSU;
            this.nsuConsulta = response.data.ultNSU;
            this.atualizarEmpresaLocal(response.data.ultNSU);
          }
          this.documentos = documentos;
          this.consultou = true;

          if (cStat === "137") {
            this.makeToast(
              "info",
              response.data.message ||
                response.data.xMotivo ||
                "Nenhum documento novo localizado na SEFAZ para esta consulta."
            );
          } else if (documentos.length === 0) {
            const meta = response.data.meta || {};
            const detalhe =
              meta.doc_zip > 0
                ? ` A SEFAZ enviou ${meta.doc_zip} arquivo(s), mas nenhum resumo de NF-e foi interpretado.`
                : "";
            this.makeToast(
              "info",
              (response.data.message ||
                "Consulta concluída sem NF-e para listar.") + detalhe
            );
          } else {
            this.makeToast(
              "success",
              `Consulta concluída. Documentos na listagem: ${documentos.length}.`
            );
          }
        } else {
          if (cStat === "656") {
            this.registrarConsumoIndevidoLocal();
          }

          // 137 pode ainda vir como success=false em versões antigas da API.
          if (cStat === "137") {
            this.documentos = documentos;
            this.consultou = true;
            this.makeToast(
              "info",
              response.data.message ||
                response.data.xMotivo ||
                "Nenhum documento localizado."
            );
            return;
          }

          this.documentos = documentos.length ? documentos : this.documentos;
          this.consultou = true;

          const motivo =
            response.data.message ||
            response.data.xMotivo ||
            "Consulta sem retorno.";

          this.makeToast(
            cStat === "656" ? "danger" : "warning",
            cStat === "656"
              ? `${motivo} Próxima consulta liberada em ${this.tempoRestanteConsumoIndevido}.`
              : motivo
          );
        }
      } catch (error) {
        this.tratarErroHttp(error);
      }
    },
    async confirmarExclusao(nota) {
      const confirmou = await this.$bvModal.msgBoxConfirm(
        `Excluir a NF-e ${nota.numero || nota.chave} da listagem gravada?`,
        {
          title: "Excluir nota",
          okTitle: "Excluir",
          cancelTitle: "Cancelar",
          okVariant: "danger",
          centered: true,
        }
      );

      if (!confirmou) {
        return;
      }

      this.mensagemCarregando = "Excluindo nota...";
      this.carregando = true;
      try {
        await http.delete(`/nfe/manifestos/${nota.id}`, {
          data: { empresa_id: this.empresaResumo.id },
        });
        this.documentos = this.documentos.filter((item) => item.id !== nota.id);
        this.makeToast("success", "Nota excluída da listagem.");
      } catch (error) {
        this.tratarErroHttp(error);
      } finally {
        this.carregando = false;
      }
    },
    abrirManifestacao(nota) {
      this.notaSelecionada = nota;
      this.manifestacao = {
        tpEvento: "",
        xJust: "",
      };
      this.$bvModal.show("modal-manifestar-nfe");
    },
    async enviarManifestacao(eventoModal) {
      eventoModal.preventDefault();
      if (!this.notaSelecionada || !this.manifestacaoValida) {
        return;
      }

      this.mensagemCarregando = "Enviando manifestação à SEFAZ...";
      this.carregando = true;
      try {
        const response = await http.post(
          `/nfe/manifestos/${this.notaSelecionada.id}/manifestar`,
          {
            tpEvento: this.manifestacao.tpEvento,
            xJust: this.manifestacao.xJust,
          }
        );

        this.$bvModal.hide("modal-manifestar-nfe");
        this.makeToast(
          "success",
          response.data.xMotivo || "Manifestação registrada com sucesso."
        );
        await this.carregarNotasSalvas();
      } catch (error) {
        this.tratarErroHttp(error);
      } finally {
        this.carregando = false;
      }
    },
    async baixarXml(nota) {
      if (!nota || !nota.id) {
        this.makeToast("warning", "Selecione uma nota confirmada para baixar.");
        return;
      }

      if (String(nota.ultimo_evento) !== "210200") {
        this.makeToast(
          "warning",
          "O download do XML só é liberado após a Confirmação da Operação."
        );
        return;
      }

      if (this.bloqueadoConsumoIndevido) {
        this.makeToast(
          "warning",
          `Consumo indevido ativo. Aguarde ${this.tempoRestanteConsumoIndevido} para baixar o XML.`
        );
        return;
      }

      this.mensagemCarregando = "Baixando XML da SEFAZ...";
      this.carregando = true;
      try {
        const response = await http.post(
          `/nfe/manifestos/${nota.id}/baixar-xml`,
          {},
          { validateStatus: (status) => status < 500 }
        );

        if (!(response.status === 200 && response.data.success && response.data.xml)) {
          const cStat = String(response.data.cStat || "");
          if (cStat === "656") {
            this.registrarConsumoIndevidoLocal();
          }

          this.makeToast(
            "danger",
            response.data.message ||
              response.data.xMotivo ||
              "Não foi possível baixar o XML."
          );
          return;
        }

        const filename =
          response.data.filename ||
          `${nota.chave || "nfe"}-nfe.xml`;
        const blob = new Blob([response.data.xml], {
          type: "application/xml;charset=utf-8",
        });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);

        this.makeToast("success", "XML baixado com sucesso.");
      } catch (error) {
        this.tratarErroHttp(error);
      } finally {
        this.carregando = false;
      }
    },
    tratarErroHttp(error) {
      if (error.response) {
        const data = error.response.data;
        let mensagem = "Erro na requisição.";

        if (typeof data === "string" && data.trim()) {
          mensagem = data;
        } else if (data && typeof data.message === "string") {
          mensagem = data.message;
          if (
            data.error &&
            typeof data.error === "string" &&
            data.error !== data.message
          ) {
            mensagem = `${data.message} Detalhe: ${data.error}`;
          }
        } else if (data && typeof data.error === "string") {
          mensagem = data.error;
        } else if (data && data.errors) {
          mensagem =
            typeof data.errors === "string"
              ? data.errors
              : JSON.stringify(data.errors);
        } else if (data && data.xMotivo) {
          mensagem = data.xMotivo;
        }

        this.makeToast("danger", mensagem);
      } else {
        this.makeToast("danger", "Falha de comunicação com a API.");
      }
    },
    atualizarEmpresaLocal(novoNsu) {
      const origem =
        this.currentEmpresa ||
        JSON.parse(localStorage.getItem("currentEmpresa") || "null");

      if (!origem || !origem.id) {
        return;
      }

      localStorage.setItem(
        "currentEmpresa",
        JSON.stringify({
          ...origem,
          manifesto_ultimo_nsu: novoNsu,
        })
      );
    },
    back() {
      this.$emit("back");
    },
  },
};
</script>

<style scoped>
.manifesto-page {
  position: relative;
  min-height: 280px;
}

.manifesto-loading {
  position: absolute;
  inset: 0;
  z-index: 20;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.78);
  backdrop-filter: blur(1px);
}

.manifesto-loading__box {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  padding: 18px 22px;
  border: 1px solid #d9e2ec;
  border-radius: 10px;
  background: #fff;
  box-shadow: 0 8px 24px rgba(31, 45, 61, 0.12);
  text-align: center;
  color: #243447;
}

.manifesto-loading__box small {
  color: #738195;
}
</style>
